// extracted by mini-css-extract-plugin
export default {"rupee":"xPwtMn"};